export default {
  /*
   *  Colors
   */

  primary: 'rgb(131,0,30)', // deep red
  primaryLight1: 'rgb(187,14,61)',

  success: '#255425',

  secondary: 'rgb(23, 132, 172)',

  // greyscale

  greyScale7: 'rgb(107,98,98)',
  greyScale6: 'rgb(245,245,245)',
  greyScale5: 'rgb(222,222,222)',
  greyScale4: 'rgb(200, 200, 200)',
  greyScale3: 'rgb(144,144,144)',
  greyScale2: 'rgb(61,61,61)',
  greyScale1: 'rgb(36,36,36)',

  // alerts

  alertInfo: 'rgb(246, 236, 236)',

  // misc

  tableStripe: 'rgb(246, 236, 236)',

  /*
   *  Dimensions
   */

  facetsPanelWidth: '35rem',

  headerPosition: 'absolute',
};



// WEBPACK FOOTER //
// ./src/packages/@ncigdc/theme/versions/legacy.js